/* src/app/service-item/service-item/service-item.component.scss */
/*# sourceMappingURL=service-item.component.css.map */
